var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 1932 722",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    x: 645.812,
    y: 482.773,
    style: {
      fontFamily: "&quot",
      fontWeight: 1000,
      fontSize: "455.59px"
    }
  }, "MENU"), /*#__PURE__*/React.createElement("path", {
    d: "M622.532 366.125c-.615-16.216.057-72.269 0-85.874L68.838 263.856c-42.87-.645-72.704 53.401-49.034 88.906 0 0 17.649 36.146 56.315 35.845l546.413-22.482ZM622.532 175.21c.521 13.301.003 66.334.003 66.334l-327.656-3.051a73.024 73.024 0 0 1-50.259-21.696 61.378 61.378 0 0 1-18.231-48.068c1.819-23.458 20.145-35.717 38.046-40.659a97.56 97.56 0 0 1 38.884-1.95l319.213 49.09ZM622.155 480.531c.073-15.057.615-66.261.254-81.384l-429.923 12.979c-62.217.855-81.317 79.603-27.654 113.728 13.027 8.352 28.56 11.952 43.996 10.2l413.327-55.523Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu_icon.3bb00e060f791a48e021104d4134beb9.svg";
export { ForwardRef as ReactComponent };